export default __webpack_public_path__ + "locales/tr/EmptyView.json?hash=3fbbc7c3543ebfee8d07d61a2b8fae97";